import { GenericService } from '../Generic.service';

export class ComponentQuizService extends GenericService {
    readonly URI: string = '/v1/componentQuiz';

    constructor() {
        super();
        this.setUri(this.URI);
    }

    public deletarQuiz(idQuiz: number) {
        return this.delete(idQuiz);
    }

    public deletarAlternativaQuiz(idAlternativa: number) {
        return this.deleteByParams('alternativa/' + idAlternativa);
    }
}
